export default {
  title: "",
  subtitle: "",
  path: "conversion_under_request",
  paragraphs: [
    "To proceed with exchanges with a locked FX rate, you will use the exchange_under_request flag. When setting it to true, the rate shown in that moment will be the one used for the conversion later.",
  ],
  request: {
    method: "POST",
    endpoint: "/transactions",
    payload: { 
          "transaction": { 
            "currency": "BRL", 
            "exchange_currency": "USD", 
            "value": "1000.00", 
            "from_bank_account_id": "your internal cash-in BRL", 
            "to_bank_account_id": "your internal cash-in USD", 
            "subject_id": "your partner_id",
            "exchange_under_request": true
          } 
        } 
      }
  }



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionConversionUnderRequest.js